import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { AuctionStore, AuctionState } from './auction.store';
import { Observable } from 'rxjs';
import { AuctionItem } from './models/auction-item.model';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuctionQuery extends QueryEntity<AuctionState> {
  constructor(protected store: AuctionStore) {
    super(store);
  }
  /** return a single auction by ID */
  selectAuction(id: number) {
    return this.selectEntity(id);
  }
  /** return a list of all auctions */
  selectAuctions() {
    return this.selectAll();
  }
  /** returns true if the auction is no longer in the store */
  getExists(id: number): boolean {
    const item = this.getEntity(id);
    return item === undefined || item === null;
  }

  selectAuctionStatus(id: number): Observable<'active' | 'finished' | 'comingsoon'> {
    return this.selectAuction(id).pipe(
      map((auction) => {
        if (!auction) {
          return 'finished';
        }

        let now = new Date();
        if (new Date(auction.StartDate) > now) {
          return 'comingsoon';
        } else if (new Date(auction.EndDate) < now) {
          return 'finished';
        } else {
          return 'active';
        }
      })
    );
  }

  /** returns all auctions marked as favourite */
  selectFavourites(): Observable<AuctionItem[]> {
    return this.selectAll({ filterBy: (auction) => auction.Favourite !== 0 });
  }
}
